import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "catalog-products"
  }, [_c('header', {
    staticClass: "catalog-products__header"
  }, [_vm._m(0), _c('span', {
    staticClass: "catalog-products__draft-count",
    attrs: {
      "aria-live": "polite",
      "aria-atomic": "true"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.dirtyCount))]), _vm._v(" " + _vm._s(_vm.dirtyCount === 1 ? "alteração pendente" : "alterações pendentes") + " ")])]), _c('div', {
    staticClass: "catalog-products__toolbar"
  }, [_c('form', {
    staticClass: "catalog-products__search",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.applySearch.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "la la-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.searchInput,
      expression: "searchInput",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "maxlength": "100",
      "disabled": _vm.saving || _vm.imageValidationBusy,
      "placeholder": "Buscar por nome, código ou referência",
      "aria-label": "Buscar produtos"
    },
    domProps: {
      "value": _vm.searchInput
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.searchInput = $event.target.value.trim();
      }, _vm.scheduleSearch],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.searchInput ? _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.imageValidationBusy,
      "title": "Limpar busca",
      "aria-label": "Limpar busca"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('i', {
    staticClass: "la la-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _c('button', {
    staticClass: "catalog-products__refresh",
    attrs: {
      "type": "button",
      "disabled": _vm.loading || _vm.saving || _vm.imageValidationBusy || _vm.hasDrafts,
      "title": _vm.hasDrafts ? 'Publique ou desfaça as alterações antes de atualizar.' : 'Atualizar produtos'
    },
    on: {
      "click": _vm.loadProducts
    }
  }, [_c('i', {
    staticClass: "la la-sync",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atualizar ")])]), _c('article', {
    staticClass: "catalog-products__panel"
  }, [_vm.loading ? _c('div', {
    staticClass: "catalog-products__loading"
  }, [_c('span', {
    staticClass: "catalog-products__spinner"
  }), _vm._v(" Carregando produtos... ")]) : !_vm.products.length ? _c('div', {
    staticClass: "catalog-products__empty"
  }, [_vm._m(1), _c('h3', [_vm._v("Nenhum produto encontrado")]), _vm.appliedSearch ? _c('p', [_vm._v(" Tente outro termo ou limpe a busca para ver todos os produtos. ")]) : _c('p', [_vm._v("Cadastre um produto ativo no ERP para começar sua vitrine.")])]) : _c('div', {
    staticClass: "catalog-products__table-wrap"
  }, [_c('table', {
    staticClass: "catalog-products__table"
  }, [_vm._m(2), _c('tbody', _vm._l(_vm.products, function (product) {
    return _c('tr', {
      key: product.id
    }, [_c('td', {
      staticClass: "is-photo",
      attrs: {
        "data-label": "Foto"
      }
    }, [_c('div', {
      staticClass: "catalog-product-gallery",
      attrs: {
        "role": "group",
        "aria-label": "Fotos de ".concat(product.descricao)
      }
    }, [_c('div', {
      staticClass: "catalog-product-photo is-principal"
    }, [_c('span', {
      staticClass: "catalog-product-photo__label"
    }, [_vm._v("Principal")]), _c('div', {
      staticClass: "catalog-product-photo__preview"
    }, [_vm.productImage(product) ? _c('img', {
      attrs: {
        "src": _vm.productImage(product),
        "alt": "Foto principal de ".concat(product.descricao)
      }
    }) : _c('i', {
      staticClass: "la la-image",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('div', {
      staticClass: "catalog-product-photo__actions"
    }, [_c('input', {
      staticClass: "sr-only",
      attrs: {
        "id": "catalog-product-image-".concat(product.id),
        "type": "file",
        "accept": "image/png,image/jpeg,image/webp",
        "disabled": _vm.saving || _vm.imageValidationBusy,
        "aria-label": "Selecionar foto principal de ".concat(product.descricao)
      },
      on: {
        "change": function change($event) {
          return _vm.selectProductImage(product, $event);
        }
      }
    }), _c('label', {
      class: {
        'is-disabled': _vm.saving || _vm.imageValidationBusy
      },
      attrs: {
        "for": "catalog-product-image-".concat(product.id),
        "aria-label": (_vm.productImage(product) ? 'Trocar' : 'Adicionar') + ' foto principal de ' + product.descricao
      }
    }, [_vm._v(" " + _vm._s(_vm.productImage(product) ? "Trocar" : "Adicionar") + " ")]), _vm.productImage(product) ? _c('button', {
      attrs: {
        "type": "button",
        "disabled": _vm.saving || _vm.imageValidationBusy,
        "aria-label": "Remover foto principal de ".concat(product.descricao)
      },
      on: {
        "click": function click($event) {
          return _vm.removeProductImage(product);
        }
      }
    }, [_vm._v(" Remover ")]) : _vm._e(), _vm.hasImageDraft(product) ? _c('button', {
      staticClass: "is-undo",
      attrs: {
        "type": "button",
        "disabled": _vm.saving || _vm.imageValidationBusy,
        "aria-label": "Desfazer altera\xE7\xE3o da foto principal de ".concat(product.descricao)
      },
      on: {
        "click": function click($event) {
          return _vm.undoProductImage(product);
        }
      }
    }, [_vm._v(" Desfazer ")]) : _vm._e(), _c('input', {
      staticClass: "sr-only",
      attrs: {
        "id": "catalog-product-complementary-next-".concat(product.id),
        "type": "file",
        "accept": "image/png,image/jpeg,image/webp",
        "disabled": _vm.saving || _vm.imageValidationBusy || !_vm.canAddComplementaryImage(product),
        "aria-label": "Adicionar pr\xF3xima foto complementar de ".concat(product.descricao)
      },
      on: {
        "change": function change($event) {
          return _vm.selectNextComplementaryImage(product, $event);
        }
      }
    }), _c('label', {
      staticClass: "is-add-complementary",
      class: {
        'is-disabled': _vm.saving || _vm.imageValidationBusy || !_vm.canAddComplementaryImage(product)
      },
      attrs: {
        "for": "catalog-product-complementary-next-".concat(product.id),
        "aria-disabled": _vm.saving || _vm.imageValidationBusy || !_vm.canAddComplementaryImage(product),
        "aria-label": "Adicionar pr\xF3xima foto complementar de ".concat(product.descricao),
        "title": _vm.canAddComplementaryImage(product) ? 'Adicionar foto exclusiva do catálogo' : 'Este produto já possui o máximo de três fotos'
      }
    }, [_c('i', {
      staticClass: "la la-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Adicionar ")])])]), _vm._l(_vm.complementarySlots, function (slot) {
      return _c('div', {
        key: slot,
        staticClass: "catalog-product-photo is-complementary"
      }, [_c('span', {
        staticClass: "catalog-product-photo__label"
      }, [_vm._v(" " + _vm._s(slot + 1) + " ")]), _c('div', {
        staticClass: "catalog-product-photo__preview"
      }, [_vm.complementaryImage(product, slot) ? _c('img', {
        attrs: {
          "src": _vm.complementaryImage(product, slot),
          "alt": "Foto ".concat(slot + 1, " de ").concat(product.descricao)
        }
      }) : _c('i', {
        staticClass: "la la-image",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _c('div', {
        staticClass: "catalog-product-photo__actions"
      }, [_c('input', {
        staticClass: "sr-only",
        attrs: {
          "id": "catalog-product-complementary-".concat(product.id, "-").concat(slot),
          "type": "file",
          "accept": "image/png,image/jpeg,image/webp",
          "disabled": _vm.saving || _vm.imageValidationBusy,
          "aria-label": "Selecionar foto ".concat(slot + 1, " de ").concat(product.descricao)
        },
        on: {
          "change": function change($event) {
            return _vm.selectComplementaryImage(product, slot, $event);
          }
        }
      }), _c('label', {
        class: {
          'is-disabled': _vm.saving || _vm.imageValidationBusy
        },
        attrs: {
          "for": "catalog-product-complementary-".concat(product.id, "-").concat(slot),
          "aria-label": (_vm.complementaryImage(product, slot) ? 'Trocar' : 'Adicionar') + ' foto ' + (slot + 1) + ' de ' + product.descricao
        }
      }, [_vm._v(" " + _vm._s(_vm.complementaryImage(product, slot) ? "Trocar" : "Adicionar") + " ")]), _vm.complementaryImage(product, slot) ? _c('button', {
        attrs: {
          "type": "button",
          "disabled": _vm.saving || _vm.imageValidationBusy,
          "aria-label": "Remover foto ".concat(slot + 1, " de ").concat(product.descricao)
        },
        on: {
          "click": function click($event) {
            return _vm.removeComplementaryImage(product, slot);
          }
        }
      }, [_vm._v(" Remover ")]) : _vm._e(), _vm.hasComplementaryImageDraft(product, slot) ? _c('button', {
        staticClass: "is-undo",
        attrs: {
          "type": "button",
          "disabled": _vm.saving || _vm.imageValidationBusy,
          "aria-label": "Desfazer altera\xE7\xE3o da foto ".concat(slot + 1, " de ").concat(product.descricao)
        },
        on: {
          "click": function click($event) {
            return _vm.undoComplementaryImage(product, slot);
          }
        }
      }, [_vm._v(" Desfazer ")]) : _vm._e()])]);
    })], 2)]), _c('td', {
      attrs: {
        "data-label": "Produto"
      }
    }, [_c('div', {
      staticClass: "catalog-product-name"
    }, [_c('strong', [_vm._v(_vm._s(product.descricao))]), _c('small', [product.codigo ? _c('span', [_vm._v("Cód. " + _vm._s(product.codigo))]) : _vm._e(), product.grupo ? _c('span', [_vm._v(_vm._s(product.grupo))]) : _vm._e()]), !product.catalogo_elegivel ? _c('em', [_vm._v(" " + _vm._s(product.motivo_inelegivel || "Produto indisponível para publicação.") + " ")]) : _vm._e()])]), _c('td', {
      staticClass: "is-price",
      attrs: {
        "data-label": "Preço"
      }
    }, [_c('label', {
      staticClass: "catalog-product-price"
    }, [_c('span', [_vm._v("R$")]), _c('input', {
      class: {
        'is-invalid': _vm.productPriceError(product)
      },
      attrs: {
        "type": "text",
        "inputmode": "decimal",
        "maxlength": "14",
        "disabled": _vm.saving,
        "aria-invalid": Boolean(_vm.productPriceError(product)),
        "aria-label": "Pre\xE7o de ".concat(product.descricao)
      },
      domProps: {
        "value": _vm.productPriceInput(product)
      },
      on: {
        "input": function input($event) {
          return _vm.updateProductPrice(product, $event.target.value);
        },
        "blur": function blur($event) {
          return _vm.normalizeProductPrice(product);
        }
      }
    }), _vm.productPriceError(product) ? _c('small', [_vm._v(" " + _vm._s(_vm.productPriceError(product)) + " ")]) : _vm._e()])]), _c('td', {
      staticClass: "is-publish",
      attrs: {
        "data-label": "No catálogo"
      }
    }, [_c('label', {
      staticClass: "catalog-product-toggle",
      class: {
        'is-disabled': _vm.saving || !product.catalogo_elegivel && !_vm.productPublished(product)
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "disabled": _vm.saving || !product.catalogo_elegivel && !_vm.productPublished(product),
        "aria-label": "Publicar ".concat(product.descricao, " no cat\xE1logo")
      },
      domProps: {
        "checked": _vm.productPublished(product)
      },
      on: {
        "change": function change($event) {
          return _vm.toggleProduct(product, $event.target.checked);
        }
      }
    }), _vm._m(3, true), _c('em', [_vm._v(_vm._s(_vm.productPublished(product) ? "Ativo" : "Inativo"))])])]), _c('td', {
      staticClass: "is-action",
      attrs: {
        "data-label": "Ações"
      }
    }, [_c('button', {
      staticClass: "catalog-product-edit",
      attrs: {
        "type": "button",
        "disabled": _vm.saving || _vm.imageValidationBusy,
        "title": "Editar no cadastro de produtos"
      },
      on: {
        "click": function click($event) {
          return _vm.editProduct(product);
        }
      }
    }, [_c('i', {
      staticClass: "la la-pen",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar ")])])]);
  }), 0)])]), _vm.meta.total ? _c('footer', {
    staticClass: "catalog-products__pagination"
  }, [_c('p', [_vm._v(" Exibindo "), _c('strong', [_vm._v(_vm._s(_vm.meta.from || 1) + "–" + _vm._s(_vm.meta.to || _vm.products.length))]), _vm._v(" de "), _c('strong', [_vm._v(_vm._s(_vm.meta.total))]), _vm._v(" produtos ")]), _c('div', [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.loading || _vm.saving || _vm.imageValidationBusy || _vm.meta.current_page <= 1,
      "aria-label": "Página anterior"
    },
    on: {
      "click": function click($event) {
        return _vm.goToPage(_vm.meta.current_page - 1);
      }
    }
  }, [_c('i', {
    staticClass: "la la-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._l(_vm.visiblePages, function (pageNumber) {
    return _c('button', {
      key: pageNumber,
      class: {
        active: pageNumber === _vm.meta.current_page
      },
      attrs: {
        "type": "button",
        "disabled": _vm.loading || _vm.saving || _vm.imageValidationBusy,
        "aria-current": pageNumber === _vm.meta.current_page ? 'page' : null
      },
      on: {
        "click": function click($event) {
          return _vm.goToPage(pageNumber);
        }
      }
    }, [_vm._v(" " + _vm._s(pageNumber) + " ")]);
  }), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.loading || _vm.saving || _vm.imageValidationBusy || _vm.meta.current_page >= _vm.meta.last_page,
      "aria-label": "Próxima página"
    },
    on: {
      "click": function click($event) {
        return _vm.goToPage(_vm.meta.current_page + 1);
      }
    }
  }, [_c('i', {
    staticClass: "la la-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()]), _c('catalog-image-crop-modal', {
    attrs: {
      "file": _vm.cropSelection && _vm.cropSelection.file
    },
    on: {
      "apply": _vm.applyCropSelection,
      "cancel": function cancel($event) {
        _vm.cropSelection = null;
      }
    }
  }), _c('div', {
    staticClass: "catalog-products__publish-bar"
  }, [_c('div', [_vm._m(4), _c('p', [_c('strong', [_vm._v("Pronto para atualizar a vitrine?")]), _c('small', [_vm._v(" " + _vm._s(_vm.hasDrafts ? "As alterações só aparecem no catálogo depois da publicação." : "Publique para sincronizar e garantir que a vitrine está ativa.") + " ")])])]), _c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.imageValidationBusy
    },
    on: {
      "click": _vm.saveAndPublish
    }
  }, [_vm.saving ? _c('span', {
    staticClass: "catalog-products__spinner"
  }) : _c('i', {
    staticClass: "la la-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.saving ? "Publicando..." : "Salvar e publicar") + " ")])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "catalog-products__eyebrow"
  }, [_vm._v("PRODUTOS DA VITRINE")]), _c('h2', [_vm._v("Escolha o que aparece no catálogo")]), _c('p', [_vm._v(" As alterações feitas aqui usam o mesmo cadastro de produtos do ERP. Você pode publicar, ajustar o preço, trocar a foto ou abrir o cadastro completo. ")]), _c('p', [_vm._v("Fotos JPG, PNG ou WebP até 5 MB. Cada foto será ajustada em 1:1, com recorte mínimo de 800 × 800 px.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "la la-box-open",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "is-photo",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Fotos")]), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Produto")]), _c('th', {
    staticClass: "is-price",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Preço no ERP")]), _c('th', {
    staticClass: "is-publish",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("No catálogo")]), _c('th', {
    staticClass: "is-action",
    attrs: {
      "scope": "col"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Ações")])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i')]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "la la-cloud-upload-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}];
export { render, staticRenderFns };